import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { getSlidesData } from '@Container/common/client/services/api';

const bg =
    'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="349" height="196"><text x="120" y="108" fill="#dcdcdc" style="font-family: PingFangSC-Regular; font-size: 28px;">鳳凰新聞</text></svg>';

class Slides extends React.PureComponent {
    static propTypes = {
        attachmentId: PropTypes.string,
    };

    state = {
        url: '',
        img: '',
        len: 0,
    };

    async componentDidMount() {
        const { attachmentId } = this.props;
        const data = await getSlidesData(attachmentId);
        const pageUrl = location.href;
        const urlArr = pageUrl.split('/');
        const pageId = urlArr[urlArr.length - 1];
        const gotoUrl = pageUrl.replace(pageId, attachmentId);

        this.setState({
            url: pageUrl.indexOf('ishare.ifeng.com') === -1 ? data.url : gotoUrl,
            img: data.img,
            len: data.slideData.length,
        });
    }

    render() {
        const { url, img, len } = this.state;

        return (
            <div className={styles.slides_box} style={{ backgroundImage: `url(${JSON.stringify(bg)})` }}>
                <a href={url} style={{ backgroundImage: `url(${img})`, backgroundSize: 'contain' }}>
                    <div className={styles.tip}>
                        <span>{len}图</span>
                    </div>
                </a>
            </div>
        );
    }
}

export default errorBoundary(Slides);
